<template>
  <div class="systemPresetsContainer">
    <span>
        请选择生成风格
    </span>
    <ImageStyleSelect @changeImg="handleChangeImg" :options="systemPresetsImgStyleOptions"/>
  </div>
</template>

<script>
import ImageStyleSelect from '../../ImageStyleSelect/index.vue';
import { systemPresetsImgStyleOptions } from '../config'
export default {
  name: 'SystemPresets',

  components: {
    ImageStyleSelect
  },

  data() {
    return {
      systemPresetsImgStyleOptions
    };
  },

  methods: {
    handleChangeImg(style) {
      this.$emit('dataChange', {
        style
      })
    }
  },
};
</script>

<style scoped>

</style>